import { UserSessionI } from "../auth/authTypes";

export const profileTypes = {
  GET_USER_INFORMATION         : "@PROFILE/GET_USER_INFORMATION",
  GET_USER_INFORMATION_SUCCESS : "@PROFILE/GET_USER_INFORMATION_SUCCESS",
  GET_USER_INFORMATION_FAILURE : "@PROFILE/GET_USER_INFORMATION_FAILURE",
  UPDATE_INFORMATION           : "@PROFILE/UPDATE_INFORMATION",
  UPDATE_INFORMATION_SUCCESS   : "@PROFILE/UPDATE_INFORMATION_SUCCESS",
  UPDATE_INFORMATION_FAILURE   : "@PROFILE/UPDATE_INFORMATION_FAILURE",
  UPDATE_AVATAR                : "@PROFILE/UPDATE_AVATAR",
  UPDATE_AVATAR_SUCCESS        : "@PROFILE/UPDATE_AVATAR_SUCCESS",
  UPDATE_AVATAR_FAILURE        : "@PROFILE/UPDATE_AVATAR_FAILURE",
};

export interface ProfileStateI {
  userInformationLoading: boolean;
  userInformationError: string;
  updateInformationLoading: boolean;
  updateInformationError: string;
  updateAvatarLoading: boolean;
  updateAvatarError: string;
}

export interface GetUserInformationI {
  type: typeof profileTypes.GET_USER_INFORMATION;
  payload?: string;
}

export interface GetUserInformationSuccessI {
  type: typeof profileTypes.GET_USER_INFORMATION_SUCCESS;
  payload?: UserSessionI;
}

export interface GetUserInformationFailureI {
  type: typeof profileTypes.GET_USER_INFORMATION_FAILURE;
  payload?: string;
}

export interface UserPayloadI {
  timezone_id: number;
}

export interface UpdateInformationI {
  type: typeof profileTypes.UPDATE_INFORMATION;
  payload: UserPayloadI;
  successCallback: () => void;
  failureCallback: (error: string) => void;
}

export interface UpdateInformationSuccessI {
  type: typeof profileTypes.UPDATE_INFORMATION_SUCCESS;
  payload?: UserSessionI;
}

export interface UpdateInformationFailureI {
  type: typeof profileTypes.UPDATE_INFORMATION_FAILURE;
  payload?: string;
}

export interface UpdateAvatarI {
  type: typeof profileTypes.UPDATE_AVATAR;
  payload: FormData;
  successCallback?: () => void;
  failureCallback?: (error: string) => void;
}

export interface UpdateAvatarSuccessI {
  type: typeof profileTypes.UPDATE_AVATAR_SUCCESS;
  payload?: UserSessionI;
}

export interface UpdateAvatarFailureI {
  type: typeof profileTypes.UPDATE_AVATAR_FAILURE;
  payload?: string;
}

export type getProfileTypes =
  | GetUserInformationI
  | GetUserInformationSuccessI
  | GetUserInformationFailureI
  | UpdateInformationI
  | UpdateInformationSuccessI
  | UpdateInformationFailureI
  | UpdateAvatarI
  | UpdateAvatarSuccessI
  | UpdateAvatarFailureI

export enum UserRolesIdTypes {
  admin = "admin",
}
